import React from 'react';
import styles from './loader.module.scss';

const CustomLoader = () => {
  return (
    <div className={styles['dot-spinner']}>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
      <div className={styles['dot-spinner__dot']}></div>
    </div>
  );
};

export default CustomLoader;